import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import { Calendar as ReactCalendar } from 'react-calendar';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints, colors, calculateSpacing } from '@vds-core/theme';
import { BodyConfig, MicroConfig, TypographyConfig } from '@vds-core/typography';
import Icon from '@vds-core/icons';
var bodySmall = BodyConfig.getStyles(TypographyConfig.getTypescale(), 'desktop', 'small');
var micro = MicroConfig.getStyles(TypographyConfig.getTypescale(), 'desktop');
/*
fontWeightStrong represents the font weight found in 
typography used when the component is bolded. Font weight is
not exported by typography configs due to the fact that 
typography components may have multiple font weight options
*/

var fontWeightStrong = 750;
var propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Callback used to get the selected date from Calendar.
   */
  onChange: PropTypes.func,

  /**
   * The beginning of a period that shall be displayed by the Calendar. If no value is provided, the current date (new Date()) will be used.
   */
  selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),

  /**
   * A custom width can be passed to calendar for scalability purposes.
   */
  width: PropTypes.number,

  /**
   * @deprecated onChange
   */
  handleDatePick: PropTypes.func,

  /**
   * @deprecated selectedDate
   */
  activeStartDate: PropTypes.instanceOf(Date),

  /**
   * @ignore
   * config for passing through other colors
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  className: null,
  selectedDate: undefined,
  onChange: function onChange() {},
  width: undefined,
  colorConfig: colors
};
var CalendarWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CalendarWrapper",
  componentId: "sc-1qp4z5w-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n"])), calculateRem(60));
var StyledCalendar = /*#__PURE__*/styled(ReactCalendar).withConfig({
  displayName: "StyledCalendar",
  componentId: "sc-1qp4z5w-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &.react-calendar {\n    display: ", ";\n\n    z-index: 5;\n    background-color: ", ";\n    box-sizing: border-box;\n    border: ", " solid ", ";\n    padding-bottom: ", ";\n    position: relative;\n    width: ", ";\n    font-family: ", ";\n    button {\n      &:active,\n      &:hover,\n      &:visited {\n        outline: none;\n      }\n    }\n  }\n\n  .react-calendar__month-view {\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n\n  .react-calendar__month-view__weekdays {\n    color: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    padding-bottom: ", ";\n    justify-content: space-around;\n    text-align: center;\n    .react-calendar__navigation .react-calendar__month-view__weekdays__weekday {\n      flex-basis: ", " !important;\n      margin-left: ", ";\n      margin-right: ", ";\n    }\n\n    abbr[title] {\n      text-decoration: none;\n      font-family: ", ";\n    }\n  }\n\n  .react-calendar__navigation__label {\n    background-color: ", ";\n    border: none;\n    color: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    cursor: pointer;\n    outline: none;\n    display: flex;\n    flex: 1;\n    justify-content: center;\n  }\n\n  .react-calendar__navigation {\n    background-color: ", ";\n    padding: ", " 0;\n    background-color: ", ";\n    flex: 1;\n    display: flex;\n  }\n\n  .react-calendar__navigation__next-button {\n    right: ", ";\n  }\n\n  .react-calendar__navigation__prev-button {\n    left: ", ";\n  }\n\n  .react-calendar__navigation__next-button[disabled] {\n    display: none;\n  }\n\n  .react-calendar__navigation__prev-button[disabled] {\n    display: none;\n  }\n\n  .react-calendar__navigation__next-button,\n  .react-calendar__navigation__prev-button {\n    background-color: ", ";\n    border: none;\n    cursor: pointer;\n    display: flex;\n    height: ", ";\n    justify-content: center;\n    padding-bottom: 0;\n    position: absolute;\n    width: ", ";\n  }\n\n  .react-calendar__navigation__next2-button,\n  .react-calendar__navigation__prev2-button {\n    display: none;\n  }\n\n  .react-calendar__year-view__months {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__decade-view__years {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__decade-view__years {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__century-view__decades {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-calendar__month-view__days {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .react-calendar__tile {\n    flex-basis: ", " !important;\n    background-color: ", ";\n    border: none;\n    box-sizing: content-box;\n    color: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    padding: 0;\n\n    &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),\n    &.react-calendar__tile--active,\n    &.react-calendar__tile--hover,\n    &.react-calendar__tile--rangeStart,\n    &.react-calendar__tile--rangeEnd,\n    &.react-calendar__tile--rangeBothEnds {\n      background-color: ", ";\n      color: ", ";\n      cursor: pointer;\n    }\n    &:hover {\n      background-color: ", ";\n    }\n    &:focus {\n      background-color: ", ";\n    }\n\n    &:disabled {\n      color: ", ";\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n        cursor: default;\n      }\n    }\n  }\n\n  .react-calendar__month-view__days__day--neighboringMonth {\n    color: ", ";\n    font-weight: normal;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .react-calendar__navigation button[disabled] {\n    background-color: ", ";\n  }\n  .react-calendar__navigation button:enabled {\n    &:hover {\n      background-color: ", ";\n    }\n    &:focus {\n      background-color: ", ";\n    }\n  }\n"])), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? null : 'none';
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig;
  return colorConfig.white;
}, calculateRem(1), function (_ref3) {
  var colorConfig = _ref3.colorConfig;
  return colorConfig.black;
}, calculateRem(14), function (_ref4) {
  var customWidth = _ref4.customWidth;
  return customWidth ? calculateRem(customWidth) : calculateRem(288);
}, bodySmall.fontFamily, calculateRem(17), calculateRem(17), function (_ref5) {
  var colorConfig = _ref5.colorConfig;
  return colorConfig.coolGray6;
}, calculateRem(bodySmall.fontSize), bodySmall.fontFamily, fontWeightStrong, calculateRem(bodySmall.lineHeight), calculateRem(14), calculateRem(28), calculateSpacing('1X'), calculateSpacing('1X'), bodySmall.fontFamily, function (_ref6) {
  var colorConfig = _ref6.colorConfig;
  return colorConfig.white;
}, function (_ref7) {
  var colorConfig = _ref7.colorConfig;
  return colorConfig.black;
}, calculateRem(bodySmall.fontSize), bodySmall.fontFamily, fontWeightStrong, calculateRem(bodySmall.lineHeight), function (_ref8) {
  var colorConfig = _ref8.colorConfig;
  return colorConfig.white;
}, calculateSpacing('5X'), function (_ref9) {
  var colorConfig = _ref9.colorConfig;
  return colorConfig.white;
}, calculateRem(26), calculateRem(26), function (_ref10) {
  var colorConfig = _ref10.colorConfig;
  return colorConfig.white;
}, calculateRem(16), calculateRem(16), calculateRem(28), function (_ref11) {
  var colorConfig = _ref11.colorConfig;
  return colorConfig.white;
}, function (_ref12) {
  var colorConfig = _ref12.colorConfig;
  return colorConfig.black;
}, calculateRem(7), calculateRem(7), calculateRem(4), calculateRem(4), calculateRem(bodySmall.fontSize), bodySmall.fontFamily, fontWeightStrong, calculateRem(28), function (_ref13) {
  var colorConfig = _ref13.colorConfig;
  return colorConfig.black;
}, function (_ref14) {
  var colorConfig = _ref14.colorConfig;
  return colorConfig.white;
}, function (_ref15) {
  var colorConfig = _ref15.colorConfig;
  return colorConfig.white;
}, function (_ref16) {
  var colorConfig = _ref16.colorConfig;
  return colorConfig.white;
}, function (_ref17) {
  var colorConfig = _ref17.colorConfig;
  return colorConfig.coolGray3;
}, function (_ref18) {
  var colorConfig = _ref18.colorConfig;
  return colorConfig.white;
}, function (_ref19) {
  var colorConfig = _ref19.colorConfig;
  return colorConfig.coolGray3;
}, function (_ref20) {
  var colorConfig = _ref20.colorConfig;
  return colorConfig.grayLight;
}, function (_ref21) {
  var colorConfig = _ref21.colorConfig;
  return colorConfig.white;
}, function (_ref22) {
  var colorConfig = _ref22.colorConfig;
  return colorConfig.white;
}, function (_ref23) {
  var colorConfig = _ref23.colorConfig;
  return colorConfig.white;
});

var Calendar = /*#__PURE__*/function (_React$Component) {
  _inherits(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  function Calendar(_props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "_getDate", function (props) {
      if (props.error) return null;
      return _this.props.activeStartDate || _this.props.selectedDate || new Date();
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (selectedDate) {
      _this.setState({
        selectedDate: selectedDate
      });

      if (typeof _this.props.handleDatePick !== 'undefined') _this.props.handleDatePick(selectedDate);
      if (typeof _this.props.onChange !== 'undefined') _this.props.onChange(selectedDate);
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleDates", function () {
      var dates, active;
      var _this$props = _this.props,
          inactiveDates = _this$props.inactiveDates,
          activeDates = _this$props.activeDates; // add disableDates or enableDates to dates
      // when disable set active to true otherwise false.

      if (inactiveDates && inactiveDates.length) {
        dates = inactiveDates;
        active = true;
      } else if (activeDates && activeDates.length) {
        dates = activeDates;
        active = false;
      } else {
        return null;
      }

      return function (_ref24) {
        var date = _ref24.date;
        var isInactive = dates.filter(function (inactiveDate) {
          var toggleDate = new Date(inactiveDate);
          toggleDate.setHours(0, 0, 0, 0);
          return date.getTime() === toggleDate.getTime();
        });
        return !!isInactive.length ? active : !active;
      };
    });

    _this.state = {
      selectedDate: _this._getDate(_this.props)
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var selectedDate = this.state.selectedDate;
      var options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      return /*#__PURE__*/React.createElement(CalendarWrapper, null, /*#__PURE__*/React.createElement(StyledCalendar, _extends({}, this.props, {
        minDetail: "month",
        maxDetail: "month",
        colorConfig: this.props.colorConfig,
        isOpen: this.props.isOpen,
        customWidth: this.props.width,
        calendarType: "US",
        formatLongDate: function formatLongDate(locale, date) {
          return date.toLocaleDateString('en', options);
        },
        formatShortWeekday: function formatShortWeekday(locale, date) {
          return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()];
        },
        tabIndex: 0,
        nextAriaLabel: 'view next month',
        nextLabel: /*#__PURE__*/React.createElement(Icon, {
          name: "caret-right",
          tabIndex: -1,
          size: "small",
          color: this.props.colorConfig.black
        }),
        onChange: this._onChange,
        prevAriaLabel: 'view previous month',
        prevLabel: /*#__PURE__*/React.createElement(Icon, {
          name: "caret-left",
          tabIndex: -1,
          size: "small",
          color: this.props.colorConfig.black
        }),
        value: selectedDate,
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        tileDisabled: this._toggleDates()
      })));
    }
  }]);

  return Calendar;
}(React.Component);

Calendar.propTypes = propTypes;
Calendar.defaultProps = defaultProps;
export default Calendar;